import * as Types from '../../graphql.generated';

import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type AddConsentMutationVariables = Types.Exact<{
    input: Types.ConsentAgreementInput;
}>;

export type AddConsentMutation = { __typename?: 'Mutation' } & Pick<
    Types.Mutation,
    'addConsent'
>;

export const AddConsentDocument = gql`
    mutation addConsent($input: ConsentAgreementInput!) {
        addConsent(input: $input)
    }
`;
export type AddConsentMutationFn = Apollo.MutationFunction<
    AddConsentMutation,
    AddConsentMutationVariables
>;

/**
 * __useAddConsentMutation__
 *
 * To run a mutation, you first call `useAddConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addConsentMutation, { data, loading, error }] = useAddConsentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddConsentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddConsentMutation,
        AddConsentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<AddConsentMutation, AddConsentMutationVariables>(
        AddConsentDocument,
        options
    );
}
export type AddConsentMutationHookResult = ReturnType<
    typeof useAddConsentMutation
>;
export type AddConsentMutationResult =
    Apollo.MutationResult<AddConsentMutation>;
export type AddConsentMutationOptions = Apollo.BaseMutationOptions<
    AddConsentMutation,
    AddConsentMutationVariables
>;
